import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/merchants'

const CmsMerchantsApiV2 = {

  /**
   * Create a Cms for Merchant
   * Invoke `POST api/v2/admins/cms/merchants'
   * @param {object} payload - Payload data to be send to backend
   */
  create: async (payload) => {
    const path = API_PATH

    const response = axios.post(path, payload)

    return response
  },
  /**
   * Update a Cms for Merchant
   * Invoke `PATCH api/v2/admins/cms/merchants/:url'
   * @param {string} url CMS Merchant Url
   * @param {object} payload - Payload data to be send to backend
   */
  update: async (url, payload) => {
    const path = `${API_PATH}/${url}`

    const response = axios.patch(path, payload)

    return response
  },
  /**
   * Show CMS Merchant by specific url
   * Invoke `GET api/v2/admins//cms/merchants/:url`
   * @param {string} url CMS Merchant Url
   */
  getSingle: async (url) => {
    const path     = `${API_PATH}/${url}`
    const response = axios.get(path)

    return response
  },
  /**
   * Get list of Cms Featured Sellers
   * Invoke `GET api/v2/admins/cms/merchants'
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async (tableState, additionalFilters) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  }

}

export default CmsMerchantsApiV2
